<script>
import ResourceService from '@/services/resources/users_service';
import AdminView from './AdminView.vue';

export default {
  extends: AdminView,
  components: {
    ActionBar: () => import('@/components/action_bars/UsersActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-account',
      urlFragment: 'users',
      headers: [
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Email', value: 'email' },
      ],
      sortBy: ['name'],
    };
  },
  computed: {
    resourceParams() {
      return {
        fields: {
          users: 'first-name,last-name,email',
        },
      };
    },
  },
};
</script>
